<template>
  <b-tab title="Upload List">
    <div class="card card-tabtop card-ornament card-ornament--green upload-list">
      <h2>Upload a list of recipients</h2>
      <p>
        You can upload a .csv file (from Excel or other source) with the recipients you want to append to your recipient list. In order for the list to be accepted, it must be a .csv file and conform to this <a :href="`${publicPath}csv/example.csv`" class="clickable underline" download>downloadable template</a>.
      </p>
      <div class="input-group">
        <div class="input-group-prepend">
          <span id="inputGroupFileAddon01" class="input-group-text" @click="onUploadClick($event)">Upload</span>
        </div>
        <div class="custom-file">
          <input id="inputFile" ref="uploads" accept=".csv" type="file" class="custom-file-input" @change="onFileChange">
          <label ref="fileLabel" class="custom-file-label" for="inputFile">Choose file</label>
        </div>
      </div>
      <p>
        <small>
          Please note: while the system supports bulk uploads, it is advised to keep your CSV files to 2,500 users or less due to connectivity and processing times. Additionally, if bulk uploading multiple lists, ensure that you are uploading only new users (not the same list plus new users). Bulk uploading lists of the same users will cause a large amount of processing time as the system will flag every repeated user as a duplicate.
        </small>
      </p>
    </div>
  </b-tab>
</template>

<script>
// https://www.papaparse.com/docs
import * as csv from 'papaparse';

export default {
  name: 'UploadTab',
  data() {
    return {
      files: [],
      publicPath: process.env.BASE_URL
    }
  },
  methods: {
    onUploadClick: function(event) {
      event.preventDefault();
      if (this.files && this.files[0]) {
        const config = {
          skipEmptyLines: true,
          header: true,
          complete: this.onParseComplete,
          error: this.onParseError,
        };
        csv.parse(this.files[0], config);
      } else {
        alert('Please select a file to upload');
      }
    },
    onFileChange: function() {
      this.files = this.$refs.uploads.files;
      if (this.files) {
        let fileName = this.files[0].name;
        this.$refs.fileLabel.innerText = fileName;
      }

      //delaying loading until hitting upload
      // const config = {
      //   skipEmptyLines: true,
      //   header: true,
      //   complete: this.onParseComplete,
      //   error: this.onParseError,
      // };
      // Start parsing then hit one of the callback
      //csv.parse(this.files[0], config);
    },
    onParseComplete: function(results) {
      const filteredData = results.data.map(recip => {
        recip.addressLine2 = (recip.addressLine2 === '') ? null : recip.addressLine2;
        return recip;
      });
      const recips = this.addOrgToRecips(filteredData);
      const payload = {
        vm: this,
        recips,
      }
      this.$store.dispatch('checkRecipient', payload);
    },
    onParseError: function(err) {
      console.log('On Parse Error: ', err);
      // TODO: Probably pop a modal here to let the user retry.
    },
    addOrgToRecips: function(recips) {
      return recips.map((item) => {
        item.organization = this.$store.getters.getUserOrg;
        return item;
      })
    }
  }
}
</script>

<style lang="scss">
.upload-list {
  .custom-file-label {
    min-height: 38px;

    &::after {
      min-height: 36px;
    }
  }

  #inputGroupFileAddon01 {
    cursor: pointer;
  }
}
</style>
